import { CommonReport } from "components/reports/show/markup";
import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { orderPriceTypes } from "helpers/enums";
import { reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { formatValue, typeSpecificProps } from "helpers/reports";
import { formatNumber } from "helpers/system";
import React from "react";

export default class SuitableOrdersReport extends CommonReport {
    extractColumns = () => {
        return [
            this.idColumn,
            {
                Header: "ID заказа",
                accessor: "orderId",
                ...typeSpecificProps({ clrType: "srting" }),
            },
            {
                Header: "Контрагент",
                accessor: "counterparty",
                ...typeSpecificProps({ clrType: "string" }),
            },
            {
                Header: "Машина",
                accessor: "carNumber",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
            },
            {
                Header: "Откуда",
                accessor: "firstPoint",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
            },
            {
                Header: "Куда",
                accessor: "lastPoint",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
            },
            {
                Header: "Организация",
                accessor: "organizationName",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
            },
            {
                Header: "Стоимость заказа",
                accessor: "price",
                ...typeSpecificProps({ clrType: "double" }),
                Cell: ({ value }) => formatNumber(value),
            },
            {
                Header: "Тип цены",
                accessor: "priceTypeDisplayName",
                Filter: reportFilterWrapper((props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            ...defaultMultipleSelectProps,
                            inputProps: { name: "priceType" },
                            components: { ValueContainer },
                            options: orderPriceTypes.map((option) => ({ label: option.label, value: option.label })),
                        }}
                    />
                )),
                filter: (rows, _id, filterValue) => {
                    if (!filterValue || !filterValue.value || filterValue.value.length === 0) {
                        return rows;
                    }
                    return rows.filter((row) => filterValue.value.includes(row.values.priceTypeDisplayName));
                },
            },
            {
                Header: "Заказ интересен?",
                accessor: "isInteresting",
                ...typeSpecificProps({ clrType: "boolean" }),
                Cell: ({ value }) => (value ? "Да" : "Нет"),
            },
            {
                Header: "Перешел по ссылке?",
                accessor: "isRedirected",
                ...typeSpecificProps({ clrType: "boolean" }),
                Cell: ({ value }) => (value ? "Да" : "Нет"),
            },
            {
                Header: "Причина отказа",
                accessor: "comment",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
            },
            {
                Header: "Логист",
                accessor: "userName",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
            },
            {
                Header: "Дата решения",
                accessor: "createdAt",
                ...typeSpecificProps({ clrType: "datetimeoffset" }),
                Cell: ({ value }) => formatValue(value, "datetimeoffset"),
            },
            { accessor: "organizationId" },
        ];
    };

    tableExtraProps = () => {
        return {
            initialState: {
                hiddenColumns: ["organizationId"],
            },
        };
    };
}
